import { Datepicker } from "vanillajs-datepicker";

import { dateFormatSwitch } from "./dateFormatSwitch";

function encode_utf8(s: string) {
    return s;
}

export function datePicker() {
    const datePickers =
        document.querySelectorAll<HTMLElement>(".datepicker-opener");

    Object.assign(Datepicker.locales, {
        de: {
            days: [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag",
            ],
            daysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
            daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
            months: [
                "Januar",
                "Februar",
                encode_utf8("M\xE4rz"),
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember",
            ],
            monthsShort: [
                "Jan",
                "Feb",
                encode_utf8("M\xE4r"),
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez",
            ],
            today: "Heute",
            monthsTitle: "Monate",
            clear: encode_utf8("L\xF6schen"),
            weekStart: 1,
        },
    });

    if (datePickers.length > 0) {
        datePickers.forEach((datePicker) => {
            const picker = new Datepicker(datePicker, {
                nextArrow:
                    '<load-svg src="/media/icon/chevron-right.svg"><style>svg{ height: 15px } svg{ margin-top: 4px } svg{ fill: #00BFFF } svg{ width: 12px }</style></load-svg>',
                prevArrow:
                    '<load-svg src="/media/icon/chevron-left.svg"><style>svg{ height: 15px } svg{ margin-top: 4px } svg{ fill: #00BFFF } svg{ width: 12px }</style></load-svg>',
                autohide: true,
                format: "yyyy-mm-dd",
                language: "de",
            });

            if (datePicker.dataset.datepickerMindate) {
                picker.setOptions({
                    minDate: datePicker.dataset.datepickerMindate,
                });
            }

            if (datePicker.dataset.datepickerMinTodayMaxEndofmonth) {
                picker.setOptions({
                    maxDate: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth() + 1,
                        0,
                    ),
                    minDate: new Date(
                        new Date().getTime() + 24 * 60 * 60 * 1000,
                    ),
                });
            }

            if (datePicker.dataset.datepickerMinToday) {
                picker.setOptions({
                    minDate: new Date(
                        new Date().getTime() + 24 * 60 * 60 * 1000,
                    ),
                });
            }

            if (datePicker.dataset.datepickerLegalage) {
                const today = new Date();
                const todayMinusLegalAge = today.setFullYear(
                    today.getFullYear() -
                        parseInt(datePicker.dataset.datepickerLegalage),
                );
                picker.setOptions({
                    maxDate: todayMinusLegalAge,
                });
            }

            const changeFormatOnlyOnStandard =
                document.querySelector(".form-standard");
            if (changeFormatOnlyOnStandard) {
                const datePickerInput = datePicker as HTMLFormElement;
                const dateDummyField =
                    datePickerInput?.previousElementSibling?.parentElement?.querySelector(
                        ".date-show",
                    ) as HTMLElement;
                const dateLabel =
                    datePickerInput?.previousElementSibling?.parentElement?.querySelector(
                        "label",
                    );

                dateDummyField?.addEventListener("click", () => {
                    dateLabel?.click();
                });
                datePickerInput.addEventListener("changeDate", () => {
                    dateDummyField.innerHTML = dateFormatSwitch(
                        datePickerInput.value,
                    );
                });
            }
        });
    }
}
